module.exports = __webpack_public_path__ + "static/media/03.Stage View.a224155f.JPG";